<template>
  <div class="Container">
    <h2 class="ViewHeading">C-1 Actions</h2>
    <b-card>
      <b-table
        sticky-header
        id="C1Table"
        :items="c1items"
        :fields="fields"
        no-border-collapse
        hover
        show-empty
        empty-text="You currently dont have any Assets of this type"
        responsive
        small
      >
        <template v-slot:cell(Action)="{ item }">
          <b-button
            variant="outline-info"
            size="sm"
            v-on:click="getDataToAction(item, 'Clarence-C1')"
          >
            Action
          </b-button>
        </template>
        <template v-slot:cell(ID)="{ item }">
          {{ getNewName(item.ID, "C1") }}
        </template>
      </b-table>
      <hr />
      </b-card>
      <b-modal 
        size="xl"
        ref="DeviceActionsModal"
        id="DeviceActionsModal"
        title="Device Actions"
        content-class="Modal"
      >
      <b-card>
        <b-row><b-col><h5><b>Device: </b> {{ getNewName(dataToDisplay[0].id,"C1") }}</h5></b-col><b-col><h5><b>Install Date: </b>{{ dataToDisplay[0].InstallDate }}</h5></b-col></b-row>
        <b-row><b-col><h5><b>Room/Area: </b> {{ dataToDisplay[0].DeptFloor}}</h5></b-col><b-col><h5><b>Position Note: </b> {{ dataToDisplay[0].LocationNote }}</h5></b-col></b-row>
        </b-card>
          <b-card>
              <b-row>
                <b-col>
                  <b-button
                    variant="outline-success"
                    block
                    v-on:click="ProbesToAdd()"
                    >Add Probe</b-button
                  >
                </b-col>
                  <b-col
                  ><b-button
                    variant="outline-danger"
                    block
                    v-on:click="ProbesToRemove()"
                    >Remove Probe</b-button
                  >
                </b-col>
                <!-- <b-col>
                  <b-button
                    variant="outline-danger"
                    block
                    v-on:click="
                      DeviceAction(dataToDisplay[0], 'SuspendToRelocate')
                    "
                    >Suspend to Relocate</b-button
                  >
                </b-col> -->
              </b-row>
              <b-row>
                <b-col>
                   <p class="small">Add new probe to existing device</p> 
                </b-col>
                <b-col>
                 <p class="small"> Remove Probes from existing device</p>
                </b-col>
                <!-- <b-col>
                  <p class = "small" v-if="dataToDisplay[0].Status == 'Active'" >Temporarily stop monitoring <br />
                  Can be reactivated</p>
                 <p class = "small" v-if="dataToDisplay[0].Status == 'Suspended'">Restart monitoring if previously suspended</p>
                 </b-col> -->
                 <!-- <b-col>
                  <p class="small">Suspend to Relocate <br />
                  Needs to be recommissioned</p>
                </b-col> -->
              </b-row>
        </b-card>
        </b-modal>
              <br />

       <b-modal id="ProbeToAdd" ref="ProbeToAdd" title="Select Probe to Add" hide-footer>
          <b-card>
          <template #header>
              Select Probe to Add to Device {{getNewName(dataToDisplay[0].id,"C1") }}
            </template>
            </b-card>
             <b-card v-if="this.dataToDisplay[0].Probe1Show=='TRUE' && this.dataToDisplay[0].Probe2Show=='TRUE'">
              All Probes already active for this device
            </b-card>
            <b-card v-if="this.dataToDisplay[0].Probe1Show!='TRUE'||this.dataToDisplay[0].Probe2Show != 'TRUE'">
            <b-row>
              <b-col>Probe:</b-col>
              <b-col>
            <b-form-select v-model="ProbeNoToAdd">
              <b-form-select-option
                value="1"
                select
                v-if="this.dataToDisplay[0].Probe1Show != 'TRUE'"
                >Probe 1</b-form-select-option
              >
              <b-form-select-option
                value="2"
                select
                v-if="this.dataToDisplay[0].Probe2Show != 'TRUE'"
                >Probe 2</b-form-select-option
              >
            </b-form-select>
            </b-col>
            </b-row>
            <br/>
            <b-row><b-col>Probe Feed:</b-col></b-row>
            <b-row>
              <b-col>
            <b-form-select v-model="Feed" :options="feedArray">
                  </b-form-select>
                  </b-col>
                  </b-row>
                  <br/>
            <b-row><b-col>Probe Position:</b-col></b-row>
            <b-row>
            <b-col>
              <b-form-select v-model="Position" :options="positionArray"></b-form-select>
            </b-col></b-row>
            <br/>
            <b-row><b-col>Recirculatory:</b-col></b-row>
            <b-row>
            <b-col><b-form-select v-model="Recirc" :options="RecircOptions"></b-form-select></b-col></b-row>
            </b-card>
            <br/>
            <b-row>
              <b-col>
              <b-button variant="outline-success" v-on:click="submitProbeAdd()">
                Submit
              </b-button>
              </b-col>
              <b-col>
              <b-button variant="outline-info"  v-on:click="cancelProbeAdd()">
                Cancel
              </b-button>
              </b-col>
            </b-row>
          </b-modal>
          <b-modal
          id="ProbeToRemoveModal"
          ref="ProbeToRemoveModal"
          title="Select Probes to Remove"
          hide-footer
        >
          <b-card>
            <template #header>
              Select Probes to Remove
            </template>
            <b-row  v-if="this.dataToDisplay[0].Probe1Show=='TRUE'">
              <b-col cols="3"> Probe 1 </b-col>
              <b-col cols="3"> {{ this.dataToDisplay[0].Probe1Feed }} </b-col>
              <b-col cols="3">
                {{ this.dataToDisplay[0].Probe1Position }}
              </b-col>
              <b-col cols="3">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="Probe1Check"
                  name="checkbox-1"
                  value="TRUE"
                  unchecked-value="FALSE"
                >
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row v-if="this.dataToDisplay[0].Probe2Show=='TRUE'">
              <b-col cols="3" > Probe 2 </b-col>
              <b-col cols="3"> {{ this.dataToDisplay[0].Probe2Feed }} </b-col>
              <b-col cols="3">
                {{ this.dataToDisplay[0].Probe2Position }}
              </b-col>
              <b-col cols="3">
                <b-form-checkbox
                  id="checkbox-2"
                  v-model="Probe2Check"
                  name="checkbox-2"
                  value="TRUE"
                  unchecked-value="FALSE"
                >
                </b-form-checkbox>
              </b-col>
            </b-row>     
            <br/> 
            <b-row>
              <b-col>
              <b-button variant="outline-success" v-on:click="submitProbeRemove()">
                Submit
              </b-button>
              </b-col>
              <b-col>
              <b-button variant="outline-info"  v-on:click="cancelProbeRemove()">
                Cancel
              </b-button>
              </b-col>
            </b-row>
            </b-card>
        </b-modal>
    <b-modal
            size="xl"
            header-bg-variant="light"
            header-text-variant="dark"
            ref="CalWizard"
            id="CalWizard"
            title="Device Calibrations"
            hide-footer>
            <b-card>
            <CALWizard @WizardComplete="FinishCALWizard" :Type="Type" :ID="ID"/>
            </b-card>

    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { IDToHuman } from "../../CustomFunctions/HumanName.js";
import CALWizard from "../CalibrationWizard/CALWizard.vue";

export default {
  props:['DataPass','Type','ID'],
  computed: {},
  components: {
    CALWizard
  },

  data() {
    return {
      UserURN: localStorage.getItem("UserURN"),
      UserProfile: localStorage.getItem("ProfilePortal"),
      clCompany: localStorage.getItem("Company"),
      nickname: localStorage.getItem("Nickname"),
      fields: [
        { key: "ID", variant: "primary" },
        { key: "Type" },
        { key: "DeptFloor" },
        { key: "PositionNote" },
        { key: "Status" },
        { key: "LocationGroups" },
        { key: "Action" },
      ],
      c1items: [],
      selectedlocation: localStorage.getItem("location"),
      DeviceIDToChange: { C1: [], O1: [] },
      IDsIhaveChanged: { C1: [], O1: [] },
      IDsToChange: { C1: [], O1: [] },
      // dataToDisplay: [{
      //         id: "",
      //         Location: "",
      //         DeptFloor: "",
      //         Position: "",
      //         Feed: "",
      //         LocationNote: "",
      //         InstallDate: "",
      //         InstallTime: "",
      //         CalibrationDate: "",
      //         CalibrationTime: "",
      //         NextServiceDate: "",
      //         NextServiceTime: "",
      //         NextServiceAction: "",
      //         LastServiceCheckDate: "",
      //         LastTempReadingDate: "",
      //         LastTempReadingTime: "",
      //         LastTempReadingMin: "",
      //         LastTempReadingMax: "",
      //         LastTempReadingAvg: "",
      //         LinkedAssets: "",
      //         NextCalibrationDate: "",
      //         SubGroupCount: "",
      //         Status: "",
      // }],
        dataToDisplay: [{
              id: "",
              Location: "",
              DeptFloor: "",
              LocationNote: "",
              NextServiceDate: "",
              NextServiceTime: "",
              NextServiceAction: "",
              LastServiceCheckDate: "",
              Probe1Show: "",
              Probe2Show: "",

              Probe1Feed: "",
              Probe1Position: "",
              Probe1LastTempMin: "",
              Probe1CalibrationDate: "",
              Probe1NextCalibrate: "",
              Probe1LastTempMax: "",
              Probe1LastTempAvg: "",

              Probe2Feed: "",
              Probe2Position: "",
              Probe2LastTempMin: "",
              Probe2CalibrationDate: "",
              Probe2NextCalibrate: "",
              Probe2LastTempMax: "",
              Probe2LastTempAvg: "",
             
              InstallDate: "",
              InstallTime: "",
              LastTempReadingDate: "",
              LastTempReadingTime: "",
              LinkedAssets: "",
              SubGroupCount: "",
             }],
      ProbeNoToAdd: "",
      Feed: "",
      Position: "",
      Recirc: null,
      feedList: "",
      feedArray: [],
      positionlist: "",
      positionArray: [],
      Probe1Check: "",
      Probe2Check: "",
      RecircOptions: [{value: null, text: 'Please select an option'},{ value: 'TRUE', text: 'True' },
          { value: 'FALSE', text: 'False' }],
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl2 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders2 = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "PositionFeed" };
    axios
      .post(LookUpUrl2, this.LookUpRequest, LookUpHeaders2)
      .then((response) => {
        this.feedList = response.data.Feeds;
        this.positionList = response.data.Positions;
        for (let i = 0; i < this.feedList.length; i++) {
          var QuoteStr = this.feedList[i][0];
          this.feedArray.push({ text: this.feedList[i][1], value: QuoteStr });
        }
        for (let i = 0; i < this.positionList.length; i++) {
          var QuoteStr2 = this.positionList[i][0];
          this.positionArray.push({text: this.positionList[i][1],value: QuoteStr2})
        }
      });
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ClarenceDeviceLocation",
      LocationDict: [
        {
          Location: this.selectedlocation,
          FilterType: "",
          Feed: "",
          State: "",
        },
      ],
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
       let fulldataarray = response.data.Values

         for (let x=0;x<fulldataarray.length;x++){
          if(fulldataarray[x][6] == 'C-1'){
            this.IDGetArrays(fulldataarray[x][0], fulldataarray[x][6]);

            this.c1items.push({
              ID: fulldataarray[x][0],
              Type: fulldataarray[x][6],
              DeptFloor: fulldataarray[x][1],
              Position: "",
              PositionNote: fulldataarray[x][2],
              LocationGroups: fulldataarray[x][3],
              grouplist: fulldataarray[x][5],
              Status: fulldataarray[x][4],
            });
          } 
        }

        this.SwitchToHuman("C1");

      });

  },

  methods: {
    async SwitchToHuman(Type) {
      if (Type == "O1") {
        let Names = await IDToHuman(this.IDsToChange.O1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.O1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.O1.push({
            ID: this.IDsToChange.O1[q],
            Name: Names[q],
          });
        }
      }

      if (Type == "C1") {
        let Names = await IDToHuman(this.IDsToChange.C1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.C1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.C1.push({
            ID: this.IDsToChange.C1[q],
            Name: Names[q],
          });
        }
      }
    },
    getNewName(data, Type) {
      let ClarenceType = Type;

      if (ClarenceType == "O1") {
        for (let i = 0; i < this.DeviceIDToChange.O1.length; i++) {
          if (data == this.DeviceIDToChange.O1[i].ID) {
            return this.DeviceIDToChange.O1[i].Name;
          }
        }
      } else {
        for (let i = 0; i < this.DeviceIDToChange.C1.length; i++) {
          if (data == this.DeviceIDToChange.C1[i].ID) {
            return this.DeviceIDToChange.C1[i].Name;
          }
        }
      }
      return data;
    },

    async IDGetArrays(ID, Type) {
      Type = Type.replace("-", "");
      if (Type == "C1") {
        if (
          this.IDsIhaveChanged.C1.includes(ID) ||
          this.IDsToChange.C1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.C1.includes(ID) == false &&
          this.IDsToChange.C1.includes(ID) == false
        ) {
          this.IDsToChange.C1.push(ID);
        }
      }
      if (Type == "O1") {
        if (
          this.IDsIhaveChanged.O1.includes(ID) ||
          this.IDsToChange.O1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.O1.includes(ID) == false &&
          this.IDsToChange.O1.includes(ID) == false
        ) {
          this.IDsToChange.O1.push(ID);
        }
      }
    },
      ProbesToAdd() {
      this.$refs["ProbeToAdd"].show();
    },
    getDataToAction(Data) {
      this.dataToDisplay = [];
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersFeed = this.$apikeyPost;
      this.LookUpRequest = {
        RequestVariable: Data.ID,
        Report: "C1DeviceDetail",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
        .then((response) => {
          let deviceData = response.data.Values;
          for (let i = 0; i < deviceData.length; i++) {
            let LinkedAssetsEndpointsArray = deviceData[i][19];

            let LinkedAssetsEndpointsData = [];
            for (let u = 0; u < LinkedAssetsEndpointsArray.length; u++) {
              LinkedAssetsEndpointsData.push({
                ID: LinkedAssetsEndpointsArray[u][0],
                Type: LinkedAssetsEndpointsArray[u][1],
              });
            }

            let p1nextcal = null
            let p2nextcal = null
            
            p1nextcal = new Date(deviceData[0][12])
            p1nextcal.setFullYear(p1nextcal.getFullYear()+1)
            p1nextcal = p1nextcal.toISOString().split('T')[0]
            if (deviceData[0][17] != null){
              p2nextcal = new Date(deviceData[0][17])
              p2nextcal.setFullYear(p2nextcal.getFullYear()+1)
              p2nextcal = p2nextcal.toISOString().split('T')[0]
          } else{
            p2nextcal = null
          } 

            this.dataToDisplay.push({
              id: deviceData[0][0],
              Location: deviceData[0][1],
              DeptFloor: deviceData[0][2],
              LocationNote: deviceData[0][3],
              NextServiceDate: deviceData[0][4],
              NextServiceTime: deviceData[0][5],
              NextServiceAction:deviceData[0][6],
              LastServiceCheckDate: deviceData[0][7],
              Probe1Show: deviceData[0][8],
              Probe2Show: deviceData[0][13],

              Probe1Feed: deviceData[0][9],
              Probe1Position: deviceData[0][10],
              Probe1LastTempMin: deviceData[0][11],
              Probe1CalibrationDate: deviceData[0][12],
              Probe1NextCalibrate: p1nextcal,
              Probe1LastTempMax: deviceData[0][24],
              Probe1LastTempAvg: deviceData[0][25],

              Probe2Feed: deviceData[0][14],
              Probe2Position: deviceData[0][15],
              Probe2LastTempMin:deviceData[0][16],
              Probe2CalibrationDate:deviceData[0][17],
              Probe2NextCalibrate: p2nextcal,
              Probe2LastTempMax: deviceData[0][26],
              Probe2LastTempAvg: deviceData[0][27],
             
              InstallDate: deviceData[0][18],
              InstallTime: deviceData[0][20],
              LastTempReadingDate: deviceData[0][21],
              LastTempReadingTime: deviceData[0][22],
              LinkedAssets: LinkedAssetsEndpointsData,
              SubGroupCount: deviceData[0][23],
            })
          }
        });
        this.$refs['DeviceActionsModal'].show()
    },
    CloseExpanded(){
      this.dataToDisplay = []
    },
        ProbesToRemove() {
      this.$refs["ProbeToRemoveModal"].show();
    },
    DeviceAction(Data, Action) {
      let ActionType = "";
      if (Action == "Activate") {
        ActionType = Action;
      }
      if (Action == "Terminate") {
        ActionType = Action;
      }
      if (Action == "Suspend") {
        ActionType = Action;
      }
      if (Action == "SuspendToRelocate") {
        ActionType = "Suspend To Relocate";
      }

      if (
        confirm("Confirm if you want to " + ActionType + " " + Data.id) == true
      ) {
        if (Action == "Suspend") {
          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/device";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            RequestType: "Suspend",
            DeviceDict: [{ DeviceID: Data.id }],
          };

          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              alert("Device Suspended for relocation");
              // this.HistorySubmit("Suspended Device " + Data.id);
              this.$refs["ClarenceActionsModal"].hide();
              this.$refs["ClarenceDetails"].hide();
              this.ReloadTables("Clarence");
            });
        }

        if (Action == "Activate") {
          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/device";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            RequestType: "Reactivate",
            DeviceDict: [{ DeviceID: Data.id }],
          };

          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              alert("Device Activated");
              // this.HistorySubmit("Activated Device " + Data.id);
              this.$refs["ClarenceActionsModal"].hide();
              this.$refs["ClarenceDetails"].hide();
              this.ReloadTables("Clarence");
            });
        }

        // Terminate STILL NEEDS PROPER CALL PUT IN PLACE THIS IS JUST A PLACEHOLDER

        if (Action == "Terminate") {
          let ThisIsFalse = false;

          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/device";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            RequestType: "Terminate",
            DeviceDict: [{ DeviceID: Data.id, Return: ThisIsFalse }],
          };
          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              alert("Device Suspended");
              // this.HistorySubmit("Suspended Device " + Data.id);
              this.$refs["ClarenceActionsModal"].hide();
              this.$refs["ClarenceDetails"].hide();
              this.ReloadTables("Clarence");
            });
        }
        // SUSPEND TO RELOCATE STILL NEEDS PROPER CALL PUT IN PLACE THIS IS JUST A PLACEHOLDER

        if (Action == "SuspendToRelocate") {
          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/device";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            RequestType: "Deactivate",
            DeviceDict: [{ DeviceID: Data.id }],
          };

          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              alert("Device Suspended");
              // this.HistorySubmit("Suspended Device " + Data.id);
              this.$refs["ClarenceActionsModal"].hide();
              this.$refs["ClarenceDetails"].hide();
              this.ReloadTables("Clarence");
            });
        }
      } else {
        alert("Device has not been actioned");
      }
    },
    ReloadTables(table){
      if(table == 'Clarence'){
       let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ClarenceDeviceLocation",
      LocationDict: [
        {
          Location: this.selectedlocation,
          FilterType: "",
          Feed: "",
          State: "",
        },
      ],
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
       let fulldataarray = response.data.Values

         for (let x=0;x<fulldataarray.length;x++){
          if(fulldataarray[x][6] == 'C-1'){
            this.IDGetArrays(fulldataarray[x][0], fulldataarray[x][6]);

            this.c1items.push({
              ID: fulldataarray[x][0],
              Type: fulldataarray[x][6],
              DeptFloor: fulldataarray[x][1],
              Position: "",
              PositionNote: fulldataarray[x][2],
              LocationGroups: fulldataarray[x][3],
              grouplist: fulldataarray[x][5],
              Status: fulldataarray[x][4],
            });
          } 
        }

        this.SwitchToHuman("C1");

      });
      }
    },
    cancelProbeAdd(){
        this.ProbeNoToAdd = "",
        this.Feed = "",
        this.Position = "",
        this.Recirc = null,
        this.$refs["ProbeToAdd"].hide();
        },
    submitProbeAdd() {
      if(this.ProbeNoToAdd == "" || this.Feed == "" || this.Position == "" || this.Recirc == null){
        alert("Please complete all fields for all probes")
      } else{
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/device";
        let LookUpHeadersFeed = this.$apikeyPost;
      this.LookUpRequest = {
          RequestType: "AddC1Probe",
          DeviceDict: [
            {
              DeviceID: this.dataToDisplay[0].id,
              ProbeNumber: this.ProbeNoToAdd,
              ProbeFeed: this.Feed.toString(),
              Position: this.Position.toString(),
              User: this.$UserURN,
              Recirculatory: this.Recirc,
            },
          ],
        };
 
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
          .then((response) => {
            response;
              this.$refs["ProbeToAdd"].hide();
              this.showCALWizard(this.dataToDisplay[0].id,"C1")
          });
        }
    },
    showCALWizard(id,devicetype){
          this.ID = id,
          this.Type = devicetype,
          this.$refs["CalWizard"].show();
        },
    FinishCALWizard(){
            this.$refs["CalWizard"].hide();
        },
    cancelProbeRemove(){
        this.Probe1Check = "",
        this.Probe2Check = "",
        this.$refs["ProbeToRemoveModal"].hide();
        },
    submitProbeRemove() {
      if (
        this.Probe1Check == "TRUE" || this.Probe2Check == "TRUE"
      ) {
        let ProbeNos = [];

        if (this.Probe1Check == "TRUE") {
          ProbeNos.push("1");
        }
        if (this.Probe2Check == "TRUE") {
          ProbeNos.push("2");
        }
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/device";
        let LookUpHeadersFeed = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "RemoveC1Probe",
          DeviceDict: [
            {
              DeviceID: this.dataToDisplay[0].id,
              ProbeNumber: ProbeNos,
            },
          ],
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
          .then((response) => {
            response;
            this.Probe1Check= ""
            this.Probe2Feed= ""
            alert("Probe Removal submitted")
            this.$refs["ProbeToRemoveModal"].hide();
            this.$refs["DeviceActionsModal"].hide();
          });
      } else {
        alert("Please ensure you select at least one probe to remove");
      }
    },
  },
  watch: {},
};
</script>

<style scoped>


</style>
